// extracted by mini-css-extract-plugin
export var calculatedBadge = "_wq-8";
export var container = "_wq-0";
export var radioDot = "_wq-5";
export var radioDotSelected = "_wq-6";
export var row = "_wq-1";
export var rowFirst = "_wq-2";
export var rowLast = "_wq-3";
export var rowSelected = "_wq-4";
export var strikethrough = "_wq-7";